import { BorrowerLoan } from 'app/models/dto/borrower-loan.model';

export class GetBorrowerLoans {
	static readonly type = '[BorrowerLoans] Get';
	constructor(public borrowerId: number) {}
}

export class UpdateBorrowerLoans {
	static readonly type = '[BorrowerLoans] Update';
	constructor(public borrowerId: number, public updates: any) {}
}

export class ClearBorrowerLoansStore {
	static readonly type = '[BorrowerLoans] Clear';
	constructor() {}
}

export class PatchBorrowerLoans {
	static readonly type = '[BorrowerLoans] Patch';
	constructor(public borrowerLoans: BorrowerLoan[]) {}
}
